<template>
	<div class="device_list">
		<div class="search">
			<el-input placeholder="请输入内容" v-model="listQuery.data.goodsName" size="mini" clearable @clear="getDataList()" @input="getDataList()" suffix-icon="el-icon-search"> </el-input>
		</div>
		<div class="tab-list">
			<span class="tab-item" :class="currentTabIndex == index ? 'active' : ''" @click="tabChangeHandle(index, item.code)" v-for="(item, index) of tabs" :key="index">{{ item.val }}</span>
		</div>
		<ul v-loading="dataListLoading">
			<li class="device_item" v-for="(goods, index) of dataList" :key="index" @dblclick="$router.push({ name: 'devicedetail', query: { prn: goods.prn } })">
				<div class="box">
					<div class="box_left">
						<div class="d_img">
							<img :src="filePreview + goods['goodsImage'][0]" alt="" />
						</div>
						<div class="d_info">
							<div style="height: 114px; display: flex; flex-direction: column; box-sizing: border-box; justify-content: space-between">
								<div class="top">
									<div class="t_l">
										<h3 class="ellipsis">{{ goods.goodsName }}</h3>
									</div>
									<div class="t_r">
										<!-- <p>
										<img src="@/assets/img/tips.png" alt="" /> 平均<span class="text_color">{{ goods.workHours }}</span
										>个工作日完成
									</p> -->
									</div>
								</div>
								<div style="font-size: 12px; color: #2962b0; cursor: pointer" @click.stop="$router.push({ name: 'devicedetail', query: { prn: goods.prn } })">查看详情</div>
								<div class="bottom">
									<el-row>
										<el-col :span="12">
											<span><span class="key">所在位置：</span>{{ goods.location }}</span>
										</el-col>
										<el-col :span="12">
											<span><span class="key">规格型号：</span>{{ goods.specModel }}</span>
										</el-col>
									</el-row>
									<el-row style="padding-top: 4px">
										<el-col :span="12">
											<span><span class="key">联系人：</span>{{ goods.deviceAdmin }}</span>
										</el-col>
										<el-col :span="12">
											<span><span class="key">联系方式：</span>{{ goods.wechat }}</span>
										</el-col>
									</el-row>
								</div>
							</div>
						</div>
					</div>
					<div class="box_right">
						<template>
							<span
								class="diy_button"
								:class="btn.code == 'ENTRUST_DETN' ? 'primary_button' : 'normal_button'"
								v-for="(btn, index) of goods.businessTypeList"
								:key="index"
								@click="orderHandle(btn.code, goods)"
								>{{ btn.val }}</span
							>
						</template>
					</div>
				</div>
			</li>
		</ul>
		<div class="mod-page">
			<pagination v-show="totalPage > 0" :total="totalPage" :page.sync="listQuery.current" :limit.sync="listQuery.size" @pagination="getDataList" />
		</div>
		<!-- 预约面板 -->
		<timepanel v-if="timeVisible" ref="timepanel" @createOrder="createOrder"></timepanel>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Timepanel from './../common/Timepanel.vue'
export default {
	components: {
		Pagination,
		Timepanel,
	},
	props: {
		deviceType: {
			type: String,
			default: 'ZXSB',
		},
	},
	computed: {
		fileUploadUrl() {
			return window.SITE_CONFIG.fileUpload
		},
		filePreview() {
			return window.SITE_CONFIG.previewFile
		},
		loginVisible: {
			get() {
				return this.$store.state.loginVisible
			},
			set(val) {
				this.$store.commit('updateLoginVisible', val)
			},
		},
		layoutMsg: {
			get() {
				return this.$store.state.layoutSearchMsg
			},
			set(val) {
				this.$store.commit('updateLayouSearMsg', val)
			},
		},
	},
	watch: {
		'listQuery.data.goodsName': {
			handler(goodsName) {
				this.$store.commit('updateLayouSearMsg', goodsName)
			},
			immediate: true,
			deep: true,
		},

		layoutMsg: {
			handler(val) {
				// console.log(val, '搜索框的值')
				if (val) {
					console.log('走的watch')
					this.listQuery.data.goodsName = val
					this.getDicByCode('ORDER_TYPE')
					this.getDicByCode('SBFL')
					// this.listQuery.data.cationType = ''
					// this.listQuery.data.gxtionType = ''
					this.getDataList()
				}
			},
			immediate: true,
			deep: true,
		},
	},
	data() {
		return {
			pageUrl: '',
			pageTitle: '',
			dataList: [],
			orderTypeList: [],
			tabs: [],
			currentTabIndex: 0,
			seflList: [],
			totalPage: 0,
			dataListLoading: false,
			timeVisible: false,

			listQuery: {
				current: 1,
				size: 20,
				data: {
					st: 1,
					goodsName: '',
					gxtionType: '',
					cationType: '',
				},
			},
		}
	},
	created() {
		console.log(this.layoutMsg, 'layoutMsglayoutMsglayoutMsg')
		if (this.layoutMsg) {
			console.log(1)
		} else {
			console.log('没走watch')
			this.pageUrl = this.$route.name
			this.pageTitle = this.$route.meta.title
			this.listQuery.data.goodsName = this.$route.query.goodsName || ''
			this.getDicByCode('ORDER_TYPE')
			this.getDicByCode('SBFL')
			this.listQuery.data.cationType = this.$route.query.code || '' //首页跳转过来
			if (this.$route.query.code || this.$route.query.routeName == 'wtsj') {
				this.listQuery.data.gxtionType = ''
			} else {
				this.listQuery.data.gxtionType = this.deviceType || ''
			}

			this.getDataList()
		}
	},
	methods: {
		// 获取列表
		getDataList() {
			this.dataListLoading = true
			this.$http
				.post(this.$api.goodsApi.goodsList, this.listQuery)
				.then(({ data }) => {
					this.dataListLoading = false
					this.dataList = data.data.list
					this.totalPage = data.data.total
				})
				.catch(() => {
					this.dataListLoading = false
				})
		},
		// 选择下单
		orderHandle(orderType, goods) {
			console.log(orderType, 'aaaaa')
			console.log(goods.prn, 'bbbbb')
			let token = this.$cookie.get('X-Web-Token')
			if (!token) {
				console.log(this.$refs)
				this.loginVisible = true
			} else {
				this.$confirm(goods.prompt, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'orderTips',
					type: 'warning',
				})
					.then(() => {
						switch (orderType) {
							//委托检测
							case 'ENTRUST_DETN':
								this.createOrder({
									goodsPrn: goods.prn,
									orderType: orderType,
								})
								break
							//SANS检测
							case 'CNAS_DETN':
								this.createOrder({
									goodsPrn: goods.prn,
									orderType: orderType,
								})
								break
							//自主上机
							case 'AUTONOMY_APP':
								this.reservationHandle(goods.prn, orderType)
								break
							//仪器预约
							case 'INSTRUMENT_APP':
								this.reservationHandle(goods.prn, orderType)
								break
							default:
								break
						}
					})
					.catch(() => {})
			}
		},
		// 创建订单
		createOrder(params) {
			this.$http.post(this.$api.orderApi.orderAdd, params).then(({ data }) => {
				console.log(data)
				this.$router.push({ name: 'order', query: { type: params.orderType, prn: params.goodsPrn, orderId: data.data, title: this.pageTitle, from: this.pageUrl } })
			})
		},
		// 预约
		reservationHandle(prn, orderType) {
			this.timeVisible = true
			this.$nextTick(() => {
				this.$refs.timepanel.init(prn, orderType, '', this.pageTitle, this.pageUrl)
			})
		},
		// 获取字典
		getDicByCode(code) {
			this.$http.get(this.$api.dicApi.getDicList, { params: { code } }).then(({ data }) => {
				code == 'ORDER_TYPE' && (this.orderTypeList = data.data)
				code == 'SBFL' && (this.tabs = [{ code: '', val: '全部设备' }, ...data.data])
				const curr = this.$route.query.code
				if (curr) {
					this.currentTabIndex = this.tabs.findIndex(v => v.code == curr)
				}
			})
		},
		// tabChangeHandle
		tabChangeHandle(index, code) {
			// this.$router.push({ name: 'centralequpt', query: {} }) //清空地址栏传参
			this.currentTabIndex = index
			this.listQuery.data.cationType = code
			this.getDataList()
		},
	},
}
</script>

<style lang="scss" scoped>
.device_list {
	.search {
		position: absolute;
		right: 36px;
		top: 8px;
	}
	.tab-list {
		font-size: 14px;
		margin-bottom: 20px;
		.tab-item {
			display: inline-block;
			background: #f5f7fa;
			margin-right: 10px;
			height: 26px;
			line-height: 26px;
			padding: 0 12px;
			border-radius: 8px;
			cursor: pointer;
			&.active {
				background-color: #2962b0;
				color: #fff;
			}
			&:hover {
				opacity: 0.8;
			}
		}
	}
	.device_item {
		padding: 16px;
		margin-bottom: 12px;
		background: #fff;
		box-shadow: 0px 2px 24px 1px rgba(0, 0, 0, 0.06);
		border-radius: 16px;
		.box {
			display: flex;
			align-items: center;
			justify-content: space-around;
			.box_left {
				display: flex;
				align-items: flex-start;
				flex: 1;
				.d_img {
					width: 160px;
					height: 120px;
					overflow: hidden;
					img {
						width: 100%;
					}
				}
				.d_info {
					flex: 1;
					margin-left: 24px;
					.top {
						display: flex;
						padding-top: 8px;
						.t_l {
							width: 65%;
							margin-right: 15px;
						}
						.t_r {
							height: 16px;
							img {
								height: 16px;
								vertical-align: bottom;
							}
							.text_color {
								color: #2962b0;
							}
						}
						h3,
						p {
							margin: 0;
							padding: 0;
						}
						h3 {
							margin-bottom: 4px;
						}
						p {
							margin-bottom: 14px;
						}
					}
					.bottom {
						line-height: 22px;
						padding-top: 14px;
						.key {
							color: #999;
						}
					}
				}
			}
			.box_right {
				display: flex;
				flex-direction: column;
				span {
					height: 26px;
					margin-bottom: 4px;
					line-height: 25px;
					padding: 0px 10px;
					font-size: 14px;
					font-weight: bold;
				}
			}
		}
	}
}
</style>
